import { cn } from '@/lib/utils';
import { useDEAIChat } from '@/hooks/use-deai-chat';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { SendHorizontal } from 'lucide-react';
import { TypingIndicator } from '@/components/typing-indicator';
import { DEAIChatMessage } from '@/components/deai-chatbox-message';
import { MicButton } from './deai-mic-button';


export const DEAIChatBox = ({ className }: { className?: string }) => {

  return (
    <div className={className}>
      <div className="shrink-0 flex flex-col gap-3">
        {/* <div className="flex gap-3">
          <Input className='h-16 md:h-16 flex-grow rounded-[3em] p-4 md:p-8 text-sm md:text-base text-black outline-none ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 bg-white/60 border-3 border-white' {...getInputProps()} />
          <Button className="rounded-full w-16 h-16" {...getSendButtonProps()}>
            <SendHorizontal className="size-7" />
          </Button>
        </div> */}
        <MicButton className={cn(
          "max-w-full w-full flex items-center justify-center rounded-full h-16 disabled:opacity-50 disabled:cursor-not-allowed"
        )} />
        <p className="text-center text-2xl text-gray-200">
          タップして話す | Tap to Talk
        </p>
      </div>
    </div>
  );
};

// New component for AI messages at the top
export const AIMessageDisplay = ({ className }: { className?: string }) => {
  const { chatMessages, isTyping } = useDEAIChat();
  
  // Get the most recent AI message
  const aiMessages = chatMessages.filter(msg => msg.role === "assistant");
  const latestAIMessage = aiMessages[aiMessages.length - 1];

  return (
    <div className={cn("fixed top-[3dvh] left-1/2 transform -translate-x-1/2 z-50 max-w-xl w-full px-4", className)}>
      {(latestAIMessage || isTyping) && (
        <div className="flex flex-col items-center">
          {latestAIMessage && (
            <DEAIChatMessage variant="transparent" className="w-full max-w-none text-center text-shadow-lg/30 bg-opacity-100">
              {latestAIMessage.content}
            </DEAIChatMessage>
          )}
          <TypingIndicator isTyping={isTyping} />
        </div>
      )}
    </div>
  );
};

// New component for user messages at the bottom
export const UserMessageDisplay = ({ className }: { className?: string }) => {
  const { chatMessages } = useDEAIChat();
  
  // Get the most recent user message
  const userMessages = chatMessages.filter(msg => msg.role === "user");
  const latestUserMessage = userMessages[userMessages.length - 1];

  return (
    <div className={cn("fixed bottom-[10dvh] left-1/2 transform -translate-x-1/2 z-50 max-w-2xl w-full px-4", className)}>
      {latestUserMessage && (
        <div className="flex flex-col items-center">
          <DEAIChatMessage variant="user" className="w-full max-w-none text-center">
            {latestUserMessage.content}
          </DEAIChatMessage>
        </div>
      )}
    </div>
  );
};